import React from "react";
import Autocomplete from "react-google-autocomplete";
import { useDispatch } from "ReusableFunctions/CustomHooks";
import { handleGoogleApiLocation, handleInput } from "Actions/commonAction/milleSearchFilterActions";
import { useSelector } from "react-redux";
import { IoClose } from "react-icons/io5";
import Select from "react-dropdown-select";

export const PoolFilter = ({
    jsonOnly, setGenderFilter, genderFilter,
    industrySectorOptions, setindustrySectorOptions, industrySectorFilter, setIndustrySectorFilter,
    sectorOptions, setSectorOptions, sectorFilter, setSectorFilter,
    functionalSpecificationOptions, setFunctionalSpecificationOptions, functionalSpecification, setFunctionalSpecification,
    jobTypeFilter, setJobTypeFilter,
    willingToRelocateFilter, setwillingToRelocateFilter,
    locationPreferenceFilter, setLocationPreferenceFilter,
    handleMellieSearch
}) => {
    const dispatch = useDispatch();
    const { location, enteredInputLocation } = useSelector((state) => state.milleSearchStates);

    const handleIndustrySector = (industrySectorValue) => {
        setIndustrySectorFilter(industrySectorValue)

        if (industrySectorValue.length > 0) {
            const checkIfValueIsOthers = industrySectorValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = industrySectorOptions.map((skills) => {
                    return skills.label !== "Others" ? { ...skills, disabled: true } : skills
                })
                setindustrySectorOptions(ChangeOtherValuesToDisable)
            } else {
                const ChangeOtherValuesToDisable = industrySectorOptions.map((skills) => {
                    return skills.label === "Others" ? { ...skills, disabled: true } : skills
                })
                setindustrySectorOptions(ChangeOtherValuesToDisable)
            }
        } else {
            const ChangeDisableFalse = industrySectorOptions.map((skills) => {
                return { ...skills, disabled: false }
            })
            setindustrySectorOptions(ChangeDisableFalse)
        }
    }

    const handleSector = (sectorValue) => {
        setSectorFilter(sectorValue)

        if (sectorValue.length > 0) {
            const checkIfValueIsOthers = sectorValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = sectorOptions.map((skills) => {
                    return skills.label !== "Others" ? { ...skills, disabled: true } : skills
                })
                setSectorOptions(ChangeOtherValuesToDisable)
            } else {
                const ChangeOtherValuesToDisable = sectorOptions.map((skills) => {
                    return skills.label === "Others" ? { ...skills, disabled: true } : skills
                })
                setSectorOptions(ChangeOtherValuesToDisable)
            }
        } else {
            const ChangeDisableFalse = sectorOptions.map((skills) => {
                return { ...skills, disabled: false }
            })
            setSectorOptions(ChangeDisableFalse)
        }
    }

    const handleFunctionalSpeci = (functionalSpeciValue) => {
        setFunctionalSpecification(functionalSpeciValue)

        if (functionalSpeciValue.length > 0) {
            const checkIfValueIsOthers = functionalSpeciValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = functionalSpecificationOptions.map((skills) => {
                    return skills.label !== "Others" ? { ...skills, disabled: true } : skills
                })
                setFunctionalSpecificationOptions(ChangeOtherValuesToDisable)
            } else {
                const ChangeOtherValuesToDisable = functionalSpecificationOptions.map((skills) => {
                    return skills.label === "Others" ? { ...skills, disabled: true } : skills
                })
                setFunctionalSpecificationOptions(ChangeOtherValuesToDisable)
            }
        } else {
            const ChangeDisableFalse = functionalSpecificationOptions.map((skills) => {
                return { ...skills, disabled: false }
            })
            setFunctionalSpecificationOptions(ChangeDisableFalse)
        }
    }

    return (
        <div className="container">
            <div className="row g-2 p-3">
                <div className="col-12">

                    <div className='mb-4'>
                        <h6 className='fw-bold'>Location</h6>
                        <div className={location.length ? 'd-flex flex-wrap mb-2' : 'd-none'}>
                            {location.map((v) => (
                                <div className="col-6 py-1 pe-1">
                                    <div className="autocomplete-location-card w-100 d-flex flex-wrap align-items-center">
                                        <div className="col-10">
                                            <p className='w-100 mb-0 text-break'>{v}</p>
                                        </div>
                                        <div className="col-2">
                                            <IoClose className='fs-5 cursorPointer' onClick={() => dispatch(handleGoogleApiLocation({ type: "delete", deletionData: v }))} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <Autocomplete
                            apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                            className='google-places-api '
                            onPlaceSelected={(place) => {
                                if (place) {
                                    dispatch(handleGoogleApiLocation({ type: "push", place: place.address_components }))
                                }
                            }}
                            onChange={(e) => dispatch(handleInput({ field: 'location', value: e.target.value }))}
                            value={enteredInputLocation}
                            disabled={location.length === 5}
                        />
                    </div>

                    <div className="col-12">
                        <div className="mb-4">
                            <h6 className="fw-bold">Gender</h6>
                            <Select
                                color="#ffa32d"
                                style={{ fontSize: ".9rem" }}
                                className="rounded-1"
                                options={jsonOnly?.gender}
                                onChange={(values) => setGenderFilter(values)}
                                values={genderFilter}
                                searchable={true}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-4">
                            <h6 className="fw-bold">Industry Sector</h6>
                            <Select
                                multi
                                color="#ffa32d"
                                style={{ fontSize: ".9rem" }}
                                className="rounded-1"
                                options={industrySectorFilter?.length < 5 ? industrySectorOptions : []}
                                addPlaceholder={"Select up to 5 Industry sector"}
                                onChange={(values) => handleIndustrySector(values)}
                                values={industrySectorFilter}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-4">
                            <h6 className="fw-bold">Sector</h6>
                            <Select
                                multi
                                color="#ffa32d"
                                style={{ fontSize: ".9rem" }}
                                className="rounded-1"
                                options={sectorFilter?.length < 5 ? sectorOptions : []}
                                addPlaceholder={"Select up to 5 sector"}
                                onChange={(values) => handleSector(values)}
                                values={sectorFilter}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-4">
                            <h6 className="fw-bold">Job Type</h6>
                            <Select
                                multi
                                color="#ffa32d"
                                style={{ fontSize: ".9rem" }}
                                className="rounded-1"
                                options={jsonOnly?.register_job_type}
                                onChange={(values) => setJobTypeFilter(values)}
                                values={jobTypeFilter}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-4">
                            <h6 className="fw-bold">Willing to relocate</h6>
                            <Select
                                color="#ffa32d"
                                style={{ fontSize: ".9rem" }}
                                className="rounded-1"
                                options={jsonOnly?.willing_to_relocate}
                                onChange={(values) => setwillingToRelocateFilter(values)}
                                values={willingToRelocateFilter}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-4">
                            <h6 className="fw-bold">Location preference</h6>
                            <Select
                                color="#ffa32d"
                                style={{ fontSize: ".9rem" }}
                                className="rounded-1"
                                options={jsonOnly?.location_preference}
                                onChange={(values) => setLocationPreferenceFilter(values)}
                                values={locationPreferenceFilter}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="mb-4">
                            <h6 className="fw-bold">Functional specification</h6>
                            <Select
                                multi
                                color="#ffa32d"
                                style={{ fontSize: ".9rem" }}
                                className="rounded-1"
                                options={functionalSpecification?.length < 5 ? functionalSpecificationOptions : []}
                                addPlaceholder={"Select up to 5 Functional specification"}
                                onChange={(values) => handleFunctionalSpeci(values)}
                                values={functionalSpecification}
                            />
                        </div>
                    </div>

                    <div className="col">
                        <button type="button" className="btn btn-transparent border btn-brand-color w-100 candidate-right-side-btn"
                            onClick={() => {
                                handleMellieSearch("ApplyFilter")
                            }}>
                            Apply Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}